var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgCodepen(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 30 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M26.531 7.5c.282.188.469.516.469.844v7.312c0 .375-.188.703-.469.89L15.563 23.86a1.064 1.064 0 01-1.172 0L3.42 16.547c-.28-.188-.421-.516-.421-.89V8.343c0-.328.14-.656.422-.844L14.39.187a1.064 1.064 0 011.171 0L26.532 7.5zM16.031 3v4.781l4.453 3 3.61-2.437L16.03 3zM13.97 3l-8.11 5.344 3.61 2.437 4.5-3V3zm-8.906 7.313v3.421L7.64 12l-2.579-1.688zm8.906 10.734v-4.781l-4.5-3-3.61 2.39 8.11 5.39zM15 14.437L18.61 12 15 9.562 11.344 12 15 14.438zm1.031 6.61l8.063-5.39-3.61-2.391-4.453 3v4.78zm8.907-7.313v-3.421L22.313 12l2.625 1.734z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgCodepen);
export default ForwardRef;
